import { Component, Input, output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, withLatestFrom } from 'rxjs/operators';

import { MediasPublicConstants } from '@features/products/medias';
import { ProductPublicModels } from '@features/products/product';
import { getResolution } from '@layout/infrastructure/state/layout.selectors';
import { getCatalogStyles } from '@pages/category/store/category-page.selectors';
import { Position, ProductViewConfig, CategoryConfiguration, ProductViewPlaceValue, GridProductStyle } from '@shared/product/models';

@Component({
    selector: 'studio-t4s',
    templateUrl: './studio-t4s.component.html',
})
export class Studiot4sComponent {
    @Input() public products: number[];

    @Input() public categoryConfiguration: CategoryConfiguration;

    @Input() public categoryId: string;

    @Input() public elementDefaultImageTypes: Map<number, string>;

    @Input() public isMediaCarouselActivated: boolean;

    @Input() public productStyle: GridProductStyle;

    public readonly clickAddToCart = output<ProductPublicModels.PublicProduct>();

    public templateConfiguration$: Observable<ProductViewConfig> = this.store.select(getResolution).pipe(
        first(),
        withLatestFrom(this.store.select(getCatalogStyles)),
        map(([_resolution, catalogStyles]: [any, Record<string, string>]) => {
            return {
                clickable: true,
                location: MediasPublicConstants.PublicMediaLocationType.category_page,
                place: ProductViewPlaceValue.PRODUCT_GRID,
                imageType: undefined,
                media: {
                    widthVW: '50vw',
                    ratio: '3-4',
                },
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                showQuicklyMobile: true,
                textPosition: Position.bottom,
                showColors: true,
                showDiscount: true,
                showMadeInExclusive: true,
                colorSelector: {
                    type: 'square',
                    colorsCount: 1,
                },
                overImageChange: false,
                showBundleName: true,
                styles: {
                    backgroundColor: catalogStyles?.backgroundColor,
                    fontColor: catalogStyles?.fontColor,
                    offerPrice: catalogStyles?.offerPrice,
                    colorSelector: catalogStyles?.colorSelector,
                    cardColor: catalogStyles?.backgroundColor,
                },
                showMediaCarousel: this.isMediaCarouselActivated,
            };
        })
    );

    constructor(
        private readonly store: Store,
    ) {}

    public addToCartSheet({ product }) {
        this.clickAddToCart.emit(product);
    }
}
